/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Text, View } from '@az/starc-ui'
import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { MCPRoute, useRoutes } from '../../router/useRoutes' 
import { CustomAnimatedAccordion } from '../../shared/CustomAnimatedAccordion/CustomAnimatedAccordion'
import styled from 'styled-components'

const NavItemLink = styled(View)(() => ({
  cursor: 'pointer',
  transition: 'all var(--st-duration-slow) var(--st-easing-standard);',
  '&:hover': {
    backgroundColor: 'var(--st-color-disabled)',
  },
}))

interface SidebarNavigationProps {
  routes?: MCPRoute[]
  parentPath?: string
}

export const SidebarNavigation: FC<SidebarNavigationProps> = ({
  routes: parentRoutes,
  parentPath,
}) => {
  const { routes } = useRoutes()

  return (
    <View borderRadius="small">
      {(parentRoutes ?? routes).map(route =>
        route.hideInSidebar === true ? null : (
          <View key={route.title} direction="column">
            {(route.childRoutes?.length || 0) > 0 ? (
              <View attributes={{ style: { marginBottom: 'var(--st-unit-1)' } }}>
                <CustomAnimatedAccordion
                  header={route.title}
                  defaultOpen={route.defaultOpen}
                  className={route.title.replace(' ', '')}
                  headerPadding={[0, 4]}
                >
                  <View>
                    <SidebarNavigation routes={route.childRoutes || []} parentPath={route.path} />
                  </View>
                </CustomAnimatedAccordion>
              </View>
            ) : (
              <NavLink to={(parentPath ?? '') + route.path || '/not-found'}>
                <View.Item>
                  <NavItemLink
                    height="50px"
                    justify="center"
                    borderRadius="small"
                    padding={[0, 10]}
                  >
                    <Text>{route.title}</Text>
                  </NavItemLink>
                </View.Item>
                <View
                  height="1px"
                  attributes={{ style: { backgroundColor: 'var(--st-color-gray-300)' } }}
                />
              </NavLink>
            )}
          </View>
        )
      )}
    </View>
  )
}
